import { Sparkles } from 'lucide-react'

export default function SuggestionChips({ suggestions, onSelect }) {
  if (!suggestions || suggestions.length === 0) return null

  return (
    <div className="cdg-suggestions">
      <span className="cdg-suggestions-label">
        <Sparkles size={12} /> Questions suggérées
      </span>
      <div className="cdg-suggestions-list">
        {suggestions.map((s, i) => (
          <button key={i} className="cdg-suggestion-chip" onClick={() => onSelect(s)}>
            {s}
          </button>
        ))}
      </div>
    </div>
  )
}
